// extracted by mini-css-extract-plugin
export default {"imageContainer":"q0-z","summaryPar":"r0-z","ratingCategories":"s0-z","reviewerInfo":"t0-z","reviewTypes":"u0-z","expanded":"v0-z"};